import { render, staticRenderFns } from "./PageTransition.vue?vue&type=template&id=a3378ddc&scoped=true&"
import script from "./PageTransition.vue?vue&type=script&lang=ts&"
export * from "./PageTransition.vue?vue&type=script&lang=ts&"
import style0 from "./PageTransition.vue?vue&type=style&index=0&id=a3378ddc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3378ddc",
  null
  
)

export default component.exports